export default __webpack_public_path__ + "static/imda20183rdprizeschool2-b8482a663710f22718dd232aaccf4283.jpg";